import { useDispatch, useSelector } from "react-redux";
import { useSearchTermsFiltersQuery } from "src/context/api/non-branded/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";
import { RootState } from "src/context/store";
import { fDate } from "src/utils/format-time";
import { setFilterLoadedKeyword } from "src/context/reducers/filter-settings/filterSlice";
import { useEffect, useState } from "react";
import { SearchTermsFilterItem } from "src/context/api/non-branded/models";
import { alpha, Stack, Typography } from "@mui/material";
import SearchTermsGrid from "../data-grid/search-terms-grid";
import TopOpportunities from "../top-opportunities";
import ClicksAdCostsChart from "../clicks-ad-costs-chart";
import VisibilityChart from "../visibility-chart";
import TopCompetitors from "../top-competitors";
import RegionSelector from "../region-selector";
import NonBrandedProvider from "../context/use-non-branded";
import useLocales from "src/locales/use-locales";
import '../_style.scss';



export default function SearchTerms() {
    const { t } = useLocales();
    const dispatch = useDispatch();
    const workspace = useCurrentWorkspace();
    const filterStore = useSelector((state: RootState) => state.filters);
    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);

    const [selectedOpportunity, setSelectedOpportunity] = useState<string | null>(null);

    const { data: searchTermsFilters } = useSearchTermsFiltersQuery({
        workspace_id: workspace?.id as number,
        start_date: fDate(filterStore.start, "yyyy-MM-dd"),
        end_date: fDate(filterStore.end, "yyyy-MM-dd"),
        devices: filterStore.devices,
        countries: selectedRegion ? [selectedRegion] : [],
        platforms: filterStore.platforms,
    }, { skip: !workspace?.id || !selectedRegion });


    useEffect(() => {
        if (searchTermsFilters) {
            dispatch(setFilterLoadedKeyword(
                searchTermsFilters.map(
                    (term: SearchTermsFilterItem) => ({
                        search_term: term.search_term,
                        total_organic_searches: term.total_clicks
                    })),
            )
            );
        }
    }, [searchTermsFilters]);

    const renderFooter = (title: string) => {
        return (
            <Stack className="card-footer" width="100%">
                <Typography className="card-footer-text" variant="caption" color="text.secondary" textAlign="center">
                    {title}
                </Typography>
            </Stack>
        );
    };
    return (
        <NonBrandedProvider values={{ selectedRegion, setSelectedRegion, selectedOpportunity, setSelectedOpportunity }}>
            <Stack direction={"column"} sx={{fontFamily: 'Public Sans'}} spacing={2} px={"24px"}>
                <RegionSelector />
                <Stack
                    direction="row"
                    spacing={2}
                    px={"24px"}
                >
                    <Stack className="card-top-header-container" overflow="hidden" width="100%" direction="column" maxHeight={224} height={224} borderRadius={2} p={0} pb={0} px={0} bgcolor="white" sx={{ border: '1px solid rgba(145, 158, 171, 0.12)' }}>
                        <ClicksAdCostsChart />
                        {renderFooter(t("dashboard.nonBrand.last12Weeks"))}
                    </Stack>
                    <Stack className="card-top-header-container" overflow="hidden" width="100%" maxHeight={224} height={224} borderRadius={2} p={0} pb={0} px={0} bgcolor="white" sx={{ border: '1px solid rgba(145, 158, 171, 0.12)' }}>
                        <VisibilityChart />

                        {renderFooter(t("dashboard.nonBrand.last12Weeks"))}
                    </Stack>
                    <Stack className="card-top-header-container" overflow="hidden" width="100%" maxHeight={224} height={224} borderRadius={2} p={0} pb={0} px={0} bgcolor="white" sx={{ border: '1px solid rgba(145, 158, 171, 0.12)' }}>
                        <TopCompetitors />
                        {renderFooter(t("dashboard.nonBrand.last12Weeks"))}
                    </Stack>
                </Stack>
                <Stack px={"24px"}>
                    <Stack borderRadius={2} m={0} bgcolor="white" sx={{ border: '1px solid rgba(145, 158, 171, 0.12)' }}>
                        <TopOpportunities />
                    </Stack>
                </Stack>
                <Stack px={"24px"}>
                    <SearchTermsGrid />
                </Stack>
            </Stack>
        </NonBrandedProvider>
    );
}